import { IModel, Model } from './model'
import { IUser, User } from './user'
import { IStatement } from '@/model/statement';

export interface IComment extends IModel {
  title: string | null
  body: string | null
  meta: CommentMeta | null
}

export class Comment extends Model implements IComment {
  public title: string | null = null
  public body: string | null = null
  public meta: CommentMeta | null = null
}

export class CommentMeta {
  public creator: IUser = new User()
  public numLikes: number = 0
  public isLiked: boolean = false
  public statements: IStatement[] = []
  public comments: IComment[] = []
  public newTitle: string = ''
  public newBody: string = ''
  public isAllJybed: boolean = false
}